import { Deserializer } from 'jsonapi-serializer';

// Actions
const GET_HOME = 'compare/GET_HOME';
const GET_HOME_LOADING = 'compare/GET_HOME_LOADING';

// Reducer
const initialState = {
  list: [],
  loading: false,
  error: false
};

// Action Creators
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case GET_HOME:
      return Object.assign({}, state, { list: action.payload, loading: false, error: false });
    case GET_HOME_LOADING:
      return Object.assign({}, state, { loading: true });
    default:
      return state;
  }
}

export function getHomeContent() {
  const url = `${config.apiHost}/home-informations`;
  return dispatch => {
    dispatch({
      type: GET_HOME_LOADING,
      payload: true
    });

    fetch(url)
      .then(response => response.json())
      .then(data => {
        new Deserializer().deserialize(data, (err, dataParsed) => {
          dispatch({
            type: GET_HOME,
            payload: dataParsed
          });
        });
      });
  };
}



// WEBPACK FOOTER //
// ./app/redux-modules/home.js